// extracted by mini-css-extract-plugin
export default {"chat":"Chat_chat__4eFo0","chatBody__title":"Chat_chatBody__title__JF8FI","chatBody__content":"Chat_chatBody__content__1mO1S","none":"Chat_none__Kd4KU"};